import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { Observable } from 'rxjs'
import { filter, map, startWith, switchMap, tap } from 'rxjs/operators'
import {
  ICON_TYPE,
  LAUNCH_CALLER,
  LaunchDialogService,
} from '@spartacus/storefront'
import {
  ActiveCartFacade,
  Cart,
  OrderEntry,
  PromotionLocation,
  PromotionResult,
} from '@spartacus/cart/base/root'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'cx-added-to-cart-dialog',
  templateUrl: './added-to-cart-dialog.component.html',
  styleUrls: ['./added-to-cart-dialog.component.scss'],
})
export class AddedToCartDialogComponent implements OnInit {
  iconTypes = ICON_TYPE

  entry$: Observable<any>
  cart$: Observable<Cart>
  loaded$: Observable<boolean>
  increment: boolean
  orderPromotions$: Observable<PromotionResult[]>
  promotionLocation: PromotionLocation = PromotionLocation.ActiveCart

  quantity = 0
  modalIsOpen = false
  product

  @ViewChild('dialog', { read: ElementRef })
  dialog: ElementRef

  form: FormGroup = new FormGroup({})

  private quantityControl$: Observable<FormControl>

  constructor(
    protected launchDialogService: LaunchDialogService,
    protected cartService: ActiveCartFacade
  ) {}
  /**
   * Returns an observable formControl with the quantity of the cartEntry,
   * but also updates the entry in case of a changed value.
   * The quantity can be set to zero in order to remove the entry.
   */
  getQuantityControl(): Observable<FormControl> {
    if (!this.quantityControl$) {
      this.quantityControl$ = this.entry$.pipe(
        filter((e) => !!e),
        map((entry) => this.getFormControl(entry)),
        switchMap(() =>
          this.form.valueChanges.pipe(
            // tslint:disable-next-line:deprecation
            startWith(null),
            tap((valueChange) => {
              if (valueChange) {
                this.cartService.updateEntry(
                  valueChange.entryNumber,
                  valueChange.quantity
                )
                if (valueChange.quantity === 0) {
                  this.dismissModal('Removed')
                }
              } else {
                this.form.markAsPristine()
              }
            })
          )
        ),
        map(() => this.form.get('quantity') as FormControl)
      )
    }
    return this.quantityControl$
  }

  ngOnInit() {
    this.launchDialogService.data$.subscribe((data) => {
      this.increment = data.increment
      this.quantity = data.quantity
      this.product = data.product
      this.entry$ = data.entry$
      this.cart$ = data.cart$
      this.loaded$ = data.loaded$
    })
    this.entry$.subscribe((success) => {})
  }

  private getFormControl(entry: OrderEntry): FormControl {
    if (!this.form.get('quantity')) {
      const quantity = new FormControl(entry.quantity, { updateOn: 'blur' })
      this.form.addControl('quantity', quantity)

      const entryNumber = new FormControl(entry.entryNumber)
      this.form.addControl('entryNumber', entryNumber)
    }
    return this.form.get('quantity') as FormControl
  }

  dismissModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      reason: reason,
      type: VS_LAUNCH_CALLER.ADD_TO_CART,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
